module.exports = __webpack_public_path__ + "static/img/10002 (2).b2a2758.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10002 (2).webp
// module id = vhM6
// module chunks = 14